import React from 'react';
import { useResponsive, useTranslation } from 'client/hooks';
import { ControlPanel, Header } from 'client/components/common/mobile';
import { HelmetComponent } from 'client/components/common';
import { staticPages as staticPagesApi } from 'client/redux/api/static-pages';
import { TARGET_VALUES } from 'models/other/interface';
import css from './ConsentForm.module.scss';
import rtCSS from 'src/routes/client/styles/RichTextContent.module.scss';

const ConsentForm = () => {
  const [isMobile] = useResponsive(['MOBILE']);
  const { translate } = useTranslation();
  const { data, isFetching } = staticPagesApi.endpoints.getStaticPage.useQuery({
    target: TARGET_VALUES.CONSENT_FORM,
  });
  const pageData = data?.success && data.data ? data.data : { title: '', body: '' };

  return (
    <>
      <HelmetComponent
        title={translate('seo.consentForm.title')}
        description={translate('seo.consentForm.description')}
        ogTitle={translate('seo.consentForm.title')}
        ogDescription={translate('seo.consentForm.description')}
      ></HelmetComponent>
      <div className={css.pageWrapper}>
        {isMobile ? <Header className={css.pageHeader} /> : null}
        {isMobile ? <ControlPanel className={css.controlPanel} /> : null}

        {pageData && (
          <div className={css.contentWrapper}>
            <div className={rtCSS.title}>{pageData?.title}</div>
            <div className={rtCSS.richTextContent} dangerouslySetInnerHTML={{ __html: pageData.body }}></div>
          </div>
        )}
      </div>
    </>
  );
};

export default ConsentForm;
